import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    View,
    FlatList,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
} from "react-native";


import {moderateScale} from '../../../../../tools/Scaling';


import HMActionBar from "../../../../../customviews/HMActionBar";


import i18n from '../../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../../tools/Tools";
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import PathFile from "../../../../../assets/PathFile";
import {typeExport} from "../../../../../redux/store/type";

import HMLoading from "../../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import store from "../../../../../redux/store";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import HMAlert from "../../../../../customviews/HMAlert";

let container = null;

import {connect} from "react-redux";
import HMIcon from "../../../../../customviews/HMIcon";
import HMListCheckBox from "../../../../../customviews/HMListCheckBox";
import axios from "axios";


class SettingMyStateScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        global.G_DataDashboard = false;
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //
        // }


        this.state = {
            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: Platform.OS === "web" ?  viewportWidth : typeExport._WIDTH,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            arraySelectCheckBoxGender: [],
            indexSelectCheckBoxGender: null,
            listDashboard: [],


        };


    }


    componentDidMount() {
        this.props.navigation.addListener('focus', () => {
                if (global.G_DataDashboard) {
                    global.G_DataDashboard = false;
                    this.getDataDashboard();

                }

                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
            }
        )
        if (!global.G_DataDashboard) {
            this.getDataDashboard();

        }
        this.props.navigation.addListener('blur', () => {
        })


        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                )


            })
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };
        paramss = Tools.addAllParams(paramss);
        this.props.callService(
            typeExport.urlApplyScreen,
            paramss,
            typeExport.TypeGetApplyScreen,
            "POST",
            this.state
        );

    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
        }
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;
        let list = this.props.route.params ? this.props.route.params.list : null;
        let _params = this.props.route.params;
        let item = _params.item;
        //  let item = _params && _params.item ? JSON.parse(_params.item) : null;


        return (


            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        {/*  <HMGradient
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                                flex: 1,
                                // alignItems: 'center'
                            }}
                            color1={"#4cee1c"}
                            color2={"#0012ee"}

                            x1="0%" y1="0%" x2="0%" y2="100%"

                        />*/}

                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != "MahalemaArak"}
                            // menu
                            back={typeExport._NameApp != "MahalemaArak"}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == "MahalemaArak"}
                            funcExit={() => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            }}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : '')) : null}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[{marginStart: moderateScale(48)}]}

                        />

                        {
                            (!this.props.DataSplashScreen.NoInternetDialogShahrdar) && (!this.props.DataSplashScreen.isLoadingShahrdar) ?
                                null
                                :
                                <View
                                    style={{
                                        width: "100%",
                                        //  flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: this.props.DataSplashScreen.NoInternetDialogShahrdar ? Colors.red : Colors.white,
                                        alignSelf: 'center',
                                        padding: moderateScale(6)
                                    }}
                                >
                                    {this.props.DataSplashScreen.NoInternetDialogShahrdar ?
                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.white,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={"خطایی رخ داده مجددا تلاش نمایید"}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.getDataServerSplash()

                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(2),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Update')}
                                                    //  text={"ثبت و بستن تیکت"}
                                                    type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                        :

                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={i18n.t('constant.Update')}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                        </View>
                                    }
                                </View>


                        }


                        <View
                            style={{
                                flex: 1,
                                // alignItems: 'center'
                            }}
                        >
                            {
                                this.props.results == null && this.props.isLoading && request_server ?
                                    <HMLoading/>

                                    :

                                    <View
                                        style={{
                                            // width: "100%",

                                            //      backgroundColor: "#048700",
                                            //position:'absolute',
                                            // flexDirection: "row",
                                            //   flexWrap: 'wrap',
                                            flex: 1,

                                            // flexGrow: 1,
                                            //  alignItems: 'center',
                                            //   justifyContent: 'center',
                                            marginTop: moderateScale(12),
                                            //  backgroundColor: _main ? "#eee" : Colors.transparent,

                                        }}>

                                        <TouchableOpacity
                                            onPress={() => {

                                                // NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                //     //  NavigationService.navigateParams("ListUserChatScreen", {
                                                //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                //     data: item, item: item,
                                                // })
                                            }
                                            }

                                            style={{
                                                alignItems: 'center',
                                                flexDirection: 'row',
                                                marginVertical: moderateScale(4)
                                            }}
                                        >

                                            <HMIcon

                                                //source={require('../../../../../assets/img/success.png')}
                                                //source={PathFile.image.background}
                                                //svg={PathFile.svg.add}
                                                type={"svg"}
                                                source={PathFile.svg.add}
                                                height={moderateScale(22)}
                                                width={moderateScale(22)}

                                                name={"add-circle-sharp"} style={{
                                                // fontSize: moderateScale(20),
                                                // color: Colors.blue,
                                                // marginHorizontal: moderateScale(4),
                                                marginRight: moderateScale(4),
                                                marginLeft: moderateScale(4),
                                                //  marginTop: moderateScale(3)
                                            }}/>


                                            <HMTextView
                                                text={"الگوی دسترسی به وضعیت ها"} type={"bold"}
                                                style={{
                                                    color: "#113956",
                                                    //marginHorizontal: moderateScale(6),
                                                    fontSize: moderateScale(14),
                                                    textAlign: 'center',

                                                }}/>

                                        </TouchableOpacity>

                                        <TouchableOpacity
                                            onPress={() => {
                                                let formData = new FormData();
                                                formData.append('page', 1);
                                                formData.append('month', 2);
                                                formData.append('startDate', 3);
                                                formData.append('endDate', 3);

                                                Tools.convertFormDataToSoap("apiLogin", formData);
                                                // NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                //     //  NavigationService.navigateParams("ListUserChatScreen", {
                                                //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                //     data: item, item: item,
                                                // })
                                            }
                                            }

                                            style={{
                                                alignItems: 'center',
                                                flexDirection: 'row',
                                                marginVertical: moderateScale(4)
                                            }}
                                        >

                                            <HMIcon

                                                //source={require('../../../../../assets/img/success.png')}
                                                //source={PathFile.image.background}
                                                //svg={PathFile.svg.add}
                                                type={"svg"}
                                                source={PathFile.svg.add}
                                                height={moderateScale(22)}
                                                width={moderateScale(22)}

                                                name={"add-circle-sharp"} style={{
                                                // fontSize: moderateScale(20),
                                                // color: Colors.blue,
                                                // marginHorizontal: moderateScale(4),
                                                marginRight: moderateScale(4),
                                                marginLeft: moderateScale(4),
                                                //  marginTop: moderateScale(3)
                                            }}/>


                                            <HMTextView
                                                text={"الگوی دسترسی به صفحات و عملگردها"} type={"bold"}
                                                style={{
                                                    color: Colors.blackLight,
                                                    //marginHorizontal: moderateScale(6),
                                                    fontSize: moderateScale(14),
                                                    textAlign: 'center',

                                                }}/>

                                        </TouchableOpacity>

                                        <TouchableOpacity
                                            onPress={() => {

                                                // NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                //     //  NavigationService.navigateParams("ListUserChatScreen", {
                                                //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                //     data: item, item: item,
                                                // })
                                            }
                                            }

                                            style={{
                                                alignItems: 'center',
                                                flexDirection: 'row',
                                                marginVertical: moderateScale(4)
                                            }}
                                        >

                                            <HMIcon

                                                //source={require('../../../../../assets/img/success.png')}
                                                //source={PathFile.image.background}
                                                //svg={PathFile.svg.add}
                                                type={"svg"}
                                                source={PathFile.svg.add}
                                                height={moderateScale(22)}
                                                width={moderateScale(22)}

                                                name={"add-circle-sharp"} style={{
                                                // fontSize: moderateScale(20),
                                                // color: Colors.blue,
                                                // marginHorizontal: moderateScale(4),
                                                marginRight: moderateScale(4),
                                                marginLeft: moderateScale(4),
                                                //  marginTop: moderateScale(3)
                                            }}/>


                                            <HMTextView
                                                text={"الگوی داشبوردهای قابل مشاهده"} type={"bold"}
                                                style={{
                                                    color: Colors.blackLight,
                                                    //marginHorizontal: moderateScale(6),
                                                    fontSize: moderateScale(14),
                                                    textAlign: 'center',

                                                }}/>

                                        </TouchableOpacity>

                                        {/*         <TouchableOpacity
                                                onPress={() => {

                                                    NavigationService.navigateParams("AddPatternMyStateScreen", {
                                                        //  NavigationService.navigateParams("ListUserChatScreen", {
                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                    })
                                                }
                                                }

                                                style={{
                                                    alignItems: 'center',
                                                    flexDirection: 'row',
                                                    marginVertical: moderateScale(4)
                                                }}
                                            >

                                                <HMIcon name={"add-circle-sharp"} style={{
                                                    fontSize: moderateScale(20),
                                                    color: Colors.blue,
                                                    marginHorizontal: moderateScale(4),
                                                    //  marginTop: moderateScale(3)
                                                }}/>


                                                <HMTextView
                                                    text={"تعریف الگوی جدید"} type={"bold"}
                                                    style={{
                                                        color: Colors.blackLight,
                                                        //marginHorizontal: moderateScale(6),
                                                        fontSize: moderateScale(14),
                                                        textAlign: 'center',

                                                    }}/>

                                            </TouchableOpacity>*/}
                                        <View style={{ minHeight: 1, minWidth: 1 }}>
                                            <HMListCheckBox
                                                data={{
                                                    // list: [
                                                    //     {id: 1, name: "الگوی مدیر سیستم مشاهده تمامی داشبورها"},
                                                    //     {id: 2, name: "الگوی مشاهده مطابق  گروه کاری های دارای دسترسی"},
                                                    //     {id: 3, name: "الگوی مشاهده مناطق و سازمانها"},
                                                    //     {id: 4, name: "الگوی مشاهده گروه کاری های سازمان پسماند"},
                                                    //     {id: 5, name: "گروه کاری های فضای سبز"},
                                                    //
                                                    // ],
                                                    //
                                                    list: this.state.listDashboard,
                                                    indexSelect: this.state['indexSelectCheckBoxGender'],
                                                    // arraySelect: this.state['arraySelectCheckBoxGender'],
                                                    name: 'Gender',
                                                    // nameSelect:"dashboard_pattern_id"

                                                }}
                                                onPress={this.onPressSelectCheckBox
                                                }
                                                 //type={"recycle"}
                                                styleRoot={{}}
                                            />
                                        </View>

                                        <TouchableOpacity
                                            onPress={() => {

                                                // NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                //     //  NavigationService.navigateParams("ListUserChatScreen", {
                                                //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                //     data: item, item: item,
                                                // })
                                            }
                                            }

                                            style={{
                                                alignItems: 'center',
                                                flexDirection: 'row',
                                                marginVertical: moderateScale(4)
                                            }}
                                        >

                                            <HMIcon

                                                //source={require('../../../../../assets/img/success.png')}
                                                //source={PathFile.image.background}
                                                //svg={PathFile.svg.add}
                                                type={"svg"}
                                                source={PathFile.svg.add}
                                                height={moderateScale(22)}
                                                width={moderateScale(22)}

                                                name={"add-circle-sharp"} style={{
                                                // fontSize: moderateScale(20),
                                                // color: Colors.blue,
                                                // marginHorizontal: moderateScale(4),
                                                marginRight: moderateScale(4),
                                                marginLeft: moderateScale(4),
                                                //  marginTop: moderateScale(3)
                                            }}/>


                                            <HMTextView
                                                text={"الگوی دسترسی به گروههای کاری"} type={"bold"}
                                                style={{
                                                    color: Colors.blackLight,
                                                    //marginHorizontal: moderateScale(6),
                                                    fontSize: moderateScale(14),
                                                    textAlign: 'center',

                                                }}/>

                                        </TouchableOpacity>

                                    </View>


                            }

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }


    onPressSelectCheckBox(item, name, check) {

        // // let idx = container.state.arraySelectCheckBoxGender.findIndex(obj => obj.id === item.id);
        //  //let arr = container.state.arraySelectCheckBoxGender;
        //
        //  if (idx !== -1) {
        //     // arr.splice(idx, 1)
        //
        //      // container.setState({
        //      //         arraySelected: arr
        //      //     },
        //      //
        //      //     () => {
        //      //         //  container.state.arraySelected.slice(container.state.indexFilter, 1)
        //      //         container.state.arraySelected.push({
        //      //             index: container.state.indexFilter,
        //      //             data: data,
        //      //             id: data.id,
        //      //             value: data.name,
        //      //             type: container.state.typeFilter
        //      //         })
        //      //     }
        //      // )
        //
        //  } else {
        //     // container.state.arraySelectCheckBoxGender.push(item)
        //      // arr = [...newState.listFilter, {...action.data}]
        //      // newState.listFilter = arr
        //  }


        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
                ['itemSelectCheckBox' + name]: item,
            },
            () => {
               let d=container.props.route.params.item;
                d["dashboard_pattern_id"]=(item.id ? item.id : item.value);
                container.setSelectDataDashboard(null, (item.id ? item.id : item.value));
            })
    }

    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }

    getDataDashboard(func) {
        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetDashboardPattern");
        formData.append('lang', i18n.locale);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('tokenLaravel', container.props.DataSplashScreen.tokenLaravel);
        //formData.append('ids', container.props.DataSplashScreen.tokenLaravel);
        //  formData.append('record', itemParams.RequestID);
        container.requestServer(
            formData, (item) => {
                let _params = this.props.route.params;
                // let item = _params.item;
                let array = item && item.patterns && item.patterns.length > 0 ? item.patterns : [];

                //let indexSelect = array.findIndex(obj => obj.id == _params.item.dashboard_pattern_id);
                //console.log("@@@", array, _params.item.dashboard_pattern_id, indexSelect)
                //let indexSelect = array.findIndex(obj => item.dashboard_pattern_id == 1);
                container.setState({
                    indexSelectCheckBoxGender: _params?.item?.dashboard_pattern_id,
                    listDashboard: array,
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {
                    func ? func() : null
                })
            }, null
        );
    }

    setSelectDataDashboard(func, id) {
        let _params = this.props.route.params;
        let item = _params.item;
        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetDashboardUnit");
        formData.append('lang', i18n.locale);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('tokenLaravel', container.props.DataSplashScreen.tokenLaravel);
        formData.append('unit_id', item.id);
        formData.append('pattern_id', id);
        Tools.addAllFormData(formData,true);

        // formData.append('ids', [item.id]);
        container.requestServer(
            formData, (item) => {

                //  let array = item && item.patterns && item.patterns.length > 0 ? item.patterns : [];

                // let indexSelect = array.findIndex(obj => item.default == 1);

                container.setState({
                    //   indexSelectCheckBoxGender: indexSelect != -1 ? indexSelect : null,
                    // listDashboard: array,
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {
                    func ? func() : null
                })
            }, null
        );
    }

    requestServer(formData, func, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    /*    HMAlert(
                            i18n.t('constant.message'),
                            data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                    }


                                },

                            ],
                            {cancelable: true}
                        )*/
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            console.log('error', e)

            // HMAlert(
            //     i18n.t('constant.message'),
            //     "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
            //     [
            //         {
            //             text: i18n.t('constant.ok'), onPress: () => {
            //
            //             }
            //
            //
            //         },
            //
            //     ],
            //     {cancelable: true}
            // )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
        })
    }
}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(SettingMyStateScreen);
